module.exports = __webpack_public_path__ + "static/media/YGG.9c156e28.png";